// src\components\FeaturesSection.tsx
import { Row, Col, Card, Typography } from 'antd';
import { SafetyOutlined, ApiOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const FeaturesSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <SafetyOutlined />,
      title: t('features.items.precision.title'),
      description: t('features.items.precision.description'),
    },
    {
      icon: <ApiOutlined />,
      title: t('features.items.api.title'),
      description: t('features.items.api.description'),
    },
    {
      icon: <ThunderboltOutlined />,
      title: t('features.items.privacy.title'),
      description: t('features.items.privacy.description'),
    },
  ];

  return (
    <section className="features-section">
      <div className="section-container">
        <div className="section-header">
          <Title level={2}>{t('features.title')}</Title>
          <Paragraph className="section-subtitle">
            {t('features.subtitle')}
          </Paragraph>
        </div>
        
        <Row gutter={[32, 32]}>
          {features.map((feature, index) => (
            <Col xs={24} md={8} key={index}>
              <Card className="feature-card" bordered={false} hoverable>
                <div className="feature-icon">{feature.icon}</div>
                <Title level={4}>{feature.title}</Title>
                <Paragraph>{feature.description}</Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default FeaturesSection;
